import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ButtonsContentTable.module.scss';
import { IcoButtonSimple } from '../IcoButton/IcoButton';
import SimpleButton from '../SimpleButton/SimpleButton';

interface ButtonsContentTableProps {
  onOpenAddPopup: () => void;
  onCopyRow: () => void;
  onDeleteRow: () => void;
  selection: number[];
  checkDisabled: boolean;
  label?: string;
  buttonText: string;
}

const ButtonsContentTable: React.FC<ButtonsContentTableProps> = (props) => {
  const { onOpenAddPopup, onCopyRow, onDeleteRow, selection, checkDisabled, label, buttonText } = props;
  const { t } = useTranslation();

  return (
    <div className={`${styles.ButtonsContentTable} ${label ? styles.WithLabel : ''}`}>
      {label && (<div className={styles.Label}>{label}</div>)}
      <div className={styles.ButtonsContentTableRight}>
        <SimpleButton
          disabled={checkDisabled}
          id="btn-add-partWithoutChange"
          color="primary"
          buttonText={buttonText}
          handleClick={onOpenAddPopup}
        />
        <IcoButtonSimple
          disabled={selection.length === 0}
          id="btn-copy-partWithoutChange"
          icon="icon-datei-doppelt-kopieren"
          tooltipText={t('software.copy')}
          handleClick={onCopyRow}
        />
        <IcoButtonSimple
          disabled={selection.length === 0}
          id="btn-delete-partWithoutChange"
          icon="icon-muelleimer-loeschen"
          tooltipText={t('software.delete')}
          handleClick={onDeleteRow}
        />
      </div>
    </div>

  );
};

export default ButtonsContentTable;
